/*************************************************************************
 * お知らせ Store Mutations
 * @namespace notice
 *************************************************************************/

export default {
  clearAllList(state) {
    state.allList = [];
    state.pagination = {
      total_pages: 0,
      current_page: 0,
      news_timelines_count: null,
      timelines_count: null,
    };
  },
  updatePagination(state, { pagination }) {
    state.pagination = pagination;
  },

  clearNews(state) {
    state.newsList = [];
    state.pagination = {
      total_pages: 0,
      current_page: 0,
      news_timelines_count: null,
      timelines_count: null,
    };
  },
  receiveAllNews(state, { news, newsTimelines, pagination }) {
    state.newsList = [...state.newsList, ...news];
    state.newsTimelines = [...state.newsTimelines, ...newsTimelines];
    state.pagination = pagination;
  },
  replaceAllNews(state, { news, newsTimelines, pagination }) {
    state.newsList = news;
    state.newsTimelines = newsTimelines;
    state.pagination = pagination;
  },
  receiveNews(state, { data }) {
    console.log('🚀 ~ file: u/notice/mutations.js ~ line 41 ~ receiveNews ~ data', data);
    state.news = data.news;
  },

  clearTimeline(state) {
    state.timelines = [];
    state.pagination = {
      total_pages: 0,
      current_page: 0,
      timelines_count: null,
      news_timelines_count: null,
    };
    state.hasClinic = null;
    state.isPartner = null;
  },
  receiveAllTimelines(state, { timelines, hasClinic, isPartner, pagination }) {
    state.timelines = [...state.timelines, ...timelines];
    state.pagination = pagination;
    state.hasClinic = hasClinic;
    state.isPartner = isPartner;
  },
  replaceAllTimelines(state, { timelines, pagination }) {
    state.timelines = timelines;
    state.pagination = pagination;
  },
  receiveTimeline(state, { data }) {
    state.timeline = data.timeline;
  },
  receiveCount(state, { data }) {
    state.timelines_count = data.timelines_count;
  },
};
